export const billingManagement = {
  backToSettingsCtaText: "Back to settings",
  formDescription:
    "Changes will take effect at the beginning of your next billing cycle.",
  formTitle: "Change Billing Cycle",
  pageTitle: "Billing Interval Management",
  radioOptions: {
    "1-month": {
      description: "Billed at ${{fullPrice}} monthly",
      title: "Every month",
      value: "1-month",
    },
    "3-months": {
      description:
        "Billed up front at ${{fullPrice}} (equivalent of ${{monthlyPrice}}/month)",
      title: "Every three months",
      value: "3-months",
    },
    "6-months": {
      description:
        "Billed up front at ${{fullPrice}} (equivalent of ${{monthlyPrice}}/month)",
      title: "Every six months",
      value: "6-months",
    },
    "12-months": {
      description:
        "Billed up front at ${{fullPrice}} (equivalent of ${{monthlyPrice}}/month)",
      title: "Every twelve months",
      value: "12-months",
    },
  },
  specialInterval: {
    description:
      "If you are on a 6- or 12-month package, please reach out to us at <EmailLink>support@weconconceive.com</EmailLink> to switch your billing plan. Changes will take effect at the beginning of your next billing cycle. Thank you!",
  },
  scheduledChange: {
    currentInterval: "Your current plan is {{plan}} billed {{interval}}.",
    scheduledInterval:
      "On {{date}}, you will switch to {{plan}} billed {{interval}}.",
  },
  submitCtaText: "Save selection",
  title: "Edit your membership",
};
